import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { TruncatedText } from "./TruncatedText.js";
function SelectButtonText({
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx(Text, {
    ...props,
    children: /* @__PURE__ */ jsx(TruncatedText, {
      children
    })
  });
}
const Text = styled.span.withConfig({
  displayName: "Text",
  componentId: "sc-46jr3k-0"
})(["width:100%;min-width:0;text-align:left;"]);
export {
  SelectButtonText
};
//# sourceMappingURL=SelectButtonText.js.map
